import React from 'react';
import '../styles/HeartReveal.css';

const HeartReveal = ({ value, label, isRevealed, onReveal }) => {
  return (
    <div className="heart-reveal-wrapper">
      <div 
        className={`heart-container ${isRevealed ? 'revealed' : ''}`}
        onClick={onReveal}
      >
        <div className="heart-shape">
          <div className="heart-base"></div>
          <div className="heart-content">
            {isRevealed ? (
              <span className="heart-value">{value}</span>
            ) : (
              <span className="heart-tap">Tap</span>
            )}
          </div>
        </div>
      </div>
      <p className="heart-label">{label}</p>
    </div>
  );
};

export default HeartReveal;